import type { FC, Ref } from "react";
import { BasicCard, type ChildrenProp } from "@huub-web/ui";

export type WinningBidCardProps = ChildrenProp & { title?: string } & {
  ref?: Ref<HTMLDivElement>;
};

/**
 * @deprecated
 */
export const WinningBidCard: FC<WinningBidCardProps> = ({
  title = "Wat wordt het winnende bod?",
  children,
  ref,
}) => (
  <BasicCard
    ref={ref}
    gap="m"
    indicatorVariant="infoSurface"
    headerDirection="horizontal"
    title={title}
    icon="trophy"
    border="default"
  >
    {children}
  </BasicCard>
);
